
import { FunctionComponent } from 'react';
import { Request, CapabilitySubAssys, RatingEnum } from '../../types/capabilityList';
import { Typography, Paper, Table, TableRow, TableCell } from '../../tailwindcomponents';
import { CheckCircle, RemoveCircle } from '../../components/icons';
import { DateTime } from 'luxon';


interface CompareRequestProps {
    request?: Request;
    isChanged: boolean;
    printMode?: boolean;
    rIndex?: number;
}

const CompareRequest: FunctionComponent<CompareRequestProps> = ({ request, isChanged, printMode, rIndex }) => {
    const generateTableBody = (row: CapabilitySubAssys, index: number) => {
        return (
            <TableRow >
                <TableCell>{row.part_number}</TableCell>
                <TableCell>{row.accepted_text}</TableCell>
                <TableCell>{row.created_date_text}</TableCell>
            </TableRow>
        )
    }

    const generateToolTableBody = (row: any, index: number) => {
        return (
            <TableRow >
                <TableCell>{row.tool_name}</TableCell>
                <TableCell>{row.part_number}</TableCell>
            </TableRow>
        )
    }
    return (
        <div >
            {(request !== undefined) &&
                <Paper elevation={3} className="p-3">
                    {printMode && <Typography margin={[0, 0, 1, 0]} color='primary' variant="h6" text={`${rIndex}`} align="center" />}
                    <div >
                        <Typography margin={[0, 0, 1, 0]} color='primary' variant="h2" text={`${printMode !== undefined ? "Capability request" : isChanged ? 'Changes made' : 'Original'}`} align="center" />
                        <div className="mt-8 mr-4 mb-8 ml-4">
                            <Typography color='primary' variant="h3" text="Part number" align="center" />
                            <Typography variant='body1' text={`${request!.part_number}`} align='center' />
                        </div>
                        <div className="mt-8 mr-4 mb-8 ml-4">
                            <Typography color='primary' variant="h3" text="Part name" align="center" />
                            <Typography variant='body1' text={`${request!.part_name}`} align='center' />
                        </div>
                        <div className="mt-8 mr-4 mb-8 ml-4">
                            <Typography color='primary' variant="h3" text="Dash numbers" align="center" />
                            {printMode ? <p className="text-center break-words"> {`${request!.dash_numbers}`}</p> :
                                <Typography variant='body1' text={`${request!.dash_numbers}`} align='center' />
                            }
                        </div>
                        <div className="mt-8 mr-4 mb-8 ml-4">
                            <Typography color='primary' variant="h3" text="CMM chapters" align="center" />
                            {printMode ? <p className="text-center break-words">{`${request!.cmm_chapters}`}</p> :
                                <Typography variant='body1' text={`${request!.cmm_chapters}`} align='center' />
                            }
                        </div>
                        <div className="mt-8 mr-4 mb-8 ml-4">
                            <Typography color='primary' variant="h3" text="ATA chapters" align="center" />
                            <Typography variant='body1' text={`${request!.ata_chapters}`} align='center' />
                        </div>
                        <div className="mt-8 mr-4 mb-8 ml-4">
                            <Typography color='primary' variant="h3" text="Class type" align="center" />
                            <Typography variant='body1' text={`${request!.class_type}`} align='center' />
                        </div>
                        <div className="mt-8 mr-4 mb-8 ml-4">
                            <Typography color='primary' variant="h3" text="Description of capability" align="center" />
                            {printMode ? <p className="text-center break-words">{`${request!.description}`}</p> :
                                <Typography variant='body1' text={`${request!.description}`} align='center' />
                            }
                        </div>
                        <div className="mt-8 mr-4 mb-8 ml-4">
                            <Typography color='primary' variant="h3" text="Manuals needed by shop" align="center" />
                            <Typography variant='body1' text={`${request!.manuals_needed_by_shop}`} align='center' />
                        </div>
                        <div className="mt-8 mr-4 mb-8 ml-4">
                            <Typography color='primary' variant="h3" text="Special training" align="center" />
                            <Typography variant='body1' text={`${request!.special_training}`} align='center' />
                        </div>
                        <div className="mt-8 mr-4 mb-8 ml-4">
                            <Typography color='primary' variant="h3" text="Rating" align="center" />
                            <Typography variant='body1' text={`${RatingEnum[request!.rating]}`} align='center' />
                        </div>
                        {request!.rating === RatingEnum.B && (
                            <>
                                <div className="mt-8 mr-4 mb-8 ml-4">
                                    <Typography color='primary' variant="h3" text="Component name" align="center" />
                                    <Typography variant='body1' text={`${request!.component_name}`} align='center' />
                                </div>
                                <div className="mt-8 mr-4 mb-8 ml-4">
                                    <Typography color='primary' variant="h3" text="Task " align="center" />
                                    <Typography variant='body1' text={`${request!.other_text}`} align='center' />
                                </div>
                            </>
                        )}
                    </div>
                    <div className="mt-8 mb-8">
                        <div>
                            <Typography margin={[2, 0, 2, 0]} color='primary' variant='h2' text={"Shops"} align='center' />
                        </div>
                        <div className="flex flex-wrap">
                            {request.shops.map((Shop, index) => (
                                <div className="w-1/4 flex flex-wrap" key={index}>
                                    <div className="flex flex-wrap justify-center">
                                        <div><Typography fontWeight="bolder" text={`${Shop.shop_name}`} align='center' /></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="mt-8 mb-8">
                        <div>
                            <Typography margin={[2, 0, 2, 0]} color='primary' variant='h2' text={"Permissions"} align='center' />
                        </div>
                        <div className="flex flex-wrap justify-center items-start gap-8">
                            <div className="flex flex-col items-center">
                                <Typography text={"OH"} align='center' />
                                {request!.is_oh
                                    ? <CheckCircle color='success' />
                                    : <RemoveCircle color="error" />}
                            </div>
                            <div className="flex flex-col items-center">
                                <Typography text={"Inspect Tested"} align='center' />
                                {request!.is_inspection_test
                                    ? <CheckCircle color='success' />
                                    : <RemoveCircle color="error" />}
                            </div>
                            <div className="flex flex-col items-center">
                                <Typography text={"MOD'S"} align='center' />
                                {request!.is_mods
                                    ? <CheckCircle color='success' />
                                    : <RemoveCircle color="error" />}
                            </div>
                            <div className="flex flex-col items-center">
                                <Typography text={"Repair"} align='center' />
                                {request!.is_repair
                                    ? <CheckCircle color='success' />
                                    : <RemoveCircle color="error" />}
                            </div>
                        </div>
                    </div>
                    <div className="mt-4 flex flex-col justify-center">
                        <div>
                            <Typography color='primary' variant='h2' text={"Sub Assy"} align='center' />
                        </div>
                        <div>
                            <Table
                                headers={["Sub Assy", "Accepted Text", "Date"]}
                                rows={request?.capability_sub_assys.filter(s => s.is_deleted === false)}
                                generateBody={(row: any, index: number) => generateTableBody(row, index)}
                                pagination={false}
                                skipIndexCol={true}
                            />
                        </div>
                    </div>
                    <div className="mt-8 mb-8">
                        <Typography color='primary' margin={[4, 0, 4, 0]} variant="h2" text="Tools" align="center" />
                    </div>
                    <div>
                        <Table
                            headers={["Tool name", "Part number"]}
                            rows={request?.capability_tools}
                            generateBody={(row: any, index: number) => generateToolTableBody(row, index)}
                            pagination={false}
                            skipIndexCol={true}
                        />
                    </div>
                    <div className="mt-8 mr-4 mb-8 ml-4">
                        <Typography color='primary' variant="h3" text="Accepted date" align="center" />
                        <Typography
                            variant='body1'
                            // originalrequest and request are not the same type
                            text={
                                request?.accepted_date
                                    ? typeof request.accepted_date === 'string'
                                        ? DateTime.fromISO(request.accepted_date).toFormat('dd.MM.yyyy HH:mm') // Handle ISO string
                                        : DateTime.fromJSDate(new Date(request.accepted_date)).toFormat('dd.MM.yyyy HH:mm') // Handle Date object
                                    : 'No date available'
                            }
                            align='center'
                        />
                    </div>
                    <div className="mt-8 mr-4 mb-8 ml-4">
                        <Typography color='primary' variant="h3" text="Accepted text" align="center" />
                        <Typography variant='body1' text={`${request!.accepted_text}`} align='center' />
                    </div>
                    <div className="mt-8 mb-8">
                        <Typography color='primary' variant="h3" text="Jira link" align="center" />
                        <Typography variant='body1' text={`${request!.jira_link}`} align='center' />
                    </div>
                </Paper>
            }
        </div>
    )
}

export default CompareRequest;